import { useEffect, useState } from "react";
import { Seo } from "@/components/Seo";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { adminApi } from "@/lib/adminApi";

/** /admin — private area. admin: null = checking, false = signed out, object = signed in. */
export default function AdminPage() {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    adminApi
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(async () => {
        try {
          const res = await adminApi.post("/auth/refresh");
          setAdmin(res.data);
        } catch {
          setAdmin(false);
        }
      });
  }, []);

  return (
    <>
      <Seo title="Admin | Tedmo Services" description="Private administration area." path="/admin" noindex />
      {admin === null && (
        <p className="py-32 text-center font-mono-sub text-xs text-mute" data-testid="admin-loading">Checking session…</p>
      )}
      {admin === false && <AdminLogin onSuccess={setAdmin} />}
      {admin && <AdminDashboard admin={admin} onLogout={() => setAdmin(false)} />}
    </>
  );
}
